import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DIMBO_CONSTANT } from '../utils/constant';

/* Simple HTTP wrapper for API endpoint calls */
@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private router: Router) { }

    /*post call*/
    public post(url: string, body: any, options?: any) {      //sagai
        const finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
        return this.http.post(finalURL, body, options);
    }


    // Method to call a GET request for Token API only
    public getCallForToken(url: string, token: any): Observable<any> { 
      let finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
      let options = {
        headers: {
            token: `bearer ${token}` ,
            'Content-Type': `application/json ; charset=utf-8` ,

        }
      }
      return this.http.get(finalURL, options);
    }

/// Generic GET method
  public get(url: string, options?: any): Observable<any> {
    const finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
    return this.http.get(finalURL, options);
  }


   /* prepare query params*/
   public prepareQueryParams(params: any): string {
    let queryParams = '?';
    for (const key in params) {
        //if (params[key] || params[key] === false) {
            let value = params[key]
            queryParams += key + '=' + value + '&';
        //}
    }
    queryParams = queryParams.substring(0, (queryParams.length - 1));
    return queryParams;
}

}
